@if (!edit){
<div class="d-flex w-100 profile-detail-row">
  <p>
    {{ title | translate }}
  </p>
  <span>{{ control.value }}</span>
</div>
} @else {
<div class="p-0 m-0 w-100">
  <p class="rightHeadings">
    {{ title | translate }}
    @if(required){<span class="text-danger">*</span>}
  </p>
  <mat-form-field appearance="outline" class="w-100 small">
    <input
      type="text"
      placeholder="{{ placeholder | translate }}"
      aria-label="type"
      matInput
      [formControl]="control"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
      <mat-option *ngFor="let item of filtered | async" [value]="item">
        {{ item }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
}
